import { Col, InputNumber, Row, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import { t } from "i18next";
import React from "react";

import { Input } from "../../../../../../components/Input/Input";
import { MandatoryField } from "../../../../../../components/MandatoryField/MandatoryField";
import { Select } from "../../../../../../components/Select/Select";
import { exciseLicencesService } from "../../../../../../modules/obligee/exciseLicences/exciseLicences.service";
import {
  IMereVelicineProps,
  ISkladisteInformacijeProps,
} from "../../../../../../modules/obligee/exciseLicences/exciseLicences.types";
import { AkciznaMarkicaKategorijaProzivoda } from "../../../../../../modules/obligee/exciseStamps/exciseStamps.types";
import { clearNonNumericValues } from "../../../../../../utils/functions";
import style from "./LicenceDetailsEditCenter.module.scss";

interface ILicenceDetailsEditCenterProps {
  meraSelect: IMereVelicineProps[];
  stateValues: ISkladisteInformacijeProps;
  kategorijaProizvodaId: number | null;
  setInformacijeSkladista: (
    updatedState: Partial<ISkladisteInformacijeProps>
  ) => void;
}

export const LicenceDetailsEditCenter: React.FC<
  ILicenceDetailsEditCenterProps
> = ({
  meraSelect,
  stateValues,
  setInformacijeSkladista,
  kategorijaProizvodaId,
}) => {
  const meraOptions = exciseLicencesService.getMeraOptions(meraSelect);

  return (
    <Col span={24} className={style.mainContainer}>
      <Row>
        <Col span={12} className="pr-55">
          {kategorijaProizvodaId === AkciznaMarkicaKategorijaProzivoda.DUVAN ? (
            <>
              <Row className={style.leftCol}>
                <Col span={11} className="alignRight pr-7">
                  <span className={style.fontSize}>
                    {MandatoryField(
                      "AKCIZNE_DOZVOLE.OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI"
                    )}
                    :
                  </span>
                </Col>
                <Col span={12}>
                  <Space.Compact style={{ width: "93%" }}>
                    <InputNumber
                      onChange={(value) =>
                        setInformacijeSkladista({
                          kolicinaProizvodaIzPrethodneGodineKg: value,
                        })
                      }
                      min={0}
                      placeholder={"kg"}
                      className={`${style.fontSize}`}
                      style={{ width: "40%" }}
                      step={0.1}
                      value={stateValues.kolicinaProizvodaIzPrethodneGodineKg}
                      name="kolicina-proizvoda-prethodne-godine-kg"
                      onKeyDown={(event) => clearNonNumericValues(event, ["."])}
                    />
                    <InputNumber
                      min={0}
                      className={`${style.fontSize}`}
                      placeholder={t("PLACEHOLDERS.KOMADI")}
                      style={{ width: "60%" }}
                      onChange={(value) =>
                        setInformacijeSkladista({
                          kolicinaProizvodaIzPrethodneGodineKomadi: value,
                        })
                      }
                      value={
                        stateValues.kolicinaProizvodaIzPrethodneGodineKomadi
                      }
                      name="kolicina-proizvoda-prethodne-godine-komadi"
                      onKeyDown={clearNonNumericValues}
                    />
                  </Space.Compact>
                </Col>
              </Row>
              <Row className={style.leftCol}>
                <Col span={11} className="alignRight pr-7">
                  <span className={style.fontSize}>
                    {MandatoryField(
                      "AKCIZNE_DOZVOLE.PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA"
                    )}
                    :
                  </span>
                </Col>
                <Col span={12}>
                  <Space.Compact style={{ width: "93%" }}>
                    <InputNumber
                      onChange={(value) =>
                        setInformacijeSkladista({
                          planiranaProizvodnjaProizvodaKg: value,
                        })
                      }
                      min={0}
                      placeholder={"kg"}
                      className={`${style.fontSize}`}
                      style={{ width: "40%" }}
                      step={0.1}
                      value={stateValues.planiranaProizvodnjaProizvodaKg}
                      name="planirane-kolicine-godisnje-proizvodnje-kg"
                      onKeyDown={(event) => clearNonNumericValues(event, ["."])}
                    />
                    <InputNumber
                      min={0}
                      className={`${style.fontSize}`}
                      placeholder={t("PLACEHOLDERS.KOMADI")}
                      style={{ width: "60%" }}
                      onChange={(value) =>
                        setInformacijeSkladista({
                          planiranaProizvodnjaProizvodaKomadi: value,
                        })
                      }
                      value={stateValues.planiranaProizvodnjaProizvodaKomadi}
                      name="planirane-kolicine-godisnje-proizvodnje-komadi"
                      onKeyDown={clearNonNumericValues}
                    />
                  </Space.Compact>
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row className={style.leftCol}>
                <Col span={11} className="alignRight pr-7">
                  <span className={style.fontSize}>
                    {MandatoryField(
                      "AKCIZNE_DOZVOLE.OSTVARENA_KOLICINA_PROIZVEDENIH_AKCIZNIH_PROIZVODA_U_PROTEKLOJ_KALENDARSKOJ_GODINI"
                    )}
                    :
                  </span>
                </Col>
                <Col span={12}>
                  <InputNumber
                    min={0}
                    onChange={(value) =>
                      setInformacijeSkladista({
                        kolicinaProizvodaIzPrethodneGodine: value,
                      })
                    }
                    value={stateValues.kolicinaProizvodaIzPrethodneGodine}
                    className={`${style.fontSize} w-93`}
                    name="kolicina-akciznih-proizvoda-proizvedenih"
                    onKeyDown={clearNonNumericValues}
                  />
                </Col>
              </Row>
              <Row className={style.leftCol}>
                <Col span={11} className="alignRight pr-7">
                  <span className={style.fontSize}>
                    {MandatoryField(
                      "AKCIZNE_DOZVOLE.PLANIRANE_KOLICINE_GODISNJE_PROIZVODNJE_AKCIZNOG_PROIZVODA"
                    )}
                    :
                  </span>
                </Col>
                <Col span={12}>
                  <InputNumber
                    min={0}
                    onChange={(value) =>
                      setInformacijeSkladista({
                        planiranaProizvodnjaProizvoda: value,
                      })
                    }
                    className={`${style.fontSize} w-93`}
                    value={stateValues.planiranaProizvodnjaProizvoda}
                    name="planiranje-kolicine-godisnje-proizvodnje"
                    onKeyDown={clearNonNumericValues}
                  />
                </Col>
              </Row>
            </>
          )}
          <Row className={style.leftCol}>
            <Col span={11} className="alignRight pr-7">
              <span className={style.fontSize}>
                {MandatoryField(
                  "AKCIZNE_DOZVOLE.BR_SKLADISTA_ZA_KOJE_TRAZI_AKCIZNU_DOZVOLU"
                )}
                :
              </span>
            </Col>
            <Col span={12}>
              <Input
                onChange={(e) =>
                  setInformacijeSkladista({
                    brojSkladistaZaDozvolu: e.target.value,
                  })
                }
                className={`${style.fontSize} w-93`}
                value={stateValues.brojSkladistaZaDozvolu}
                name="br-skladista-za-koje-trazi-akciznu-dozvolu"
              />
            </Col>
          </Row>
          <Row className={style.leftCol}>
            <Col span={11} className="alignRight pr-7">
              <span className={style.fontSize}>
                {MandatoryField("AKCIZNE_DOZVOLE.ULICA_I_BROJ")}:
              </span>
            </Col>
            <Col span={12}>
              <Space.Compact style={{ width: "93%" }}>
                <Input
                  onChange={(e) =>
                    setInformacijeSkladista({
                      ulicaSkladista: e.target.value,
                    })
                  }
                  placeholder={t("PLACEHOLDERS.ULICA")}
                  value={stateValues.ulicaSkladista}
                  className={`${style.fontSize} w-75`}
                  name="ulica"
                />
                <Input
                  onChange={(e) =>
                    setInformacijeSkladista({
                      brojUliceSkladista: e.target.value,
                    })
                  }
                  placeholder={t("PLACEHOLDERS.BROJ")}
                  value={stateValues.brojUliceSkladista}
                  className={`${style.fontSize} w-25`}
                  name="broj"
                />
              </Space.Compact>
            </Col>
          </Row>
          <Row className={style.leftCol}>
            <Col span={11} className="alignRight pr-7">
              <span className={style.fontSize}>
                {MandatoryField("AKCIZNE_DOZVOLE.POSTANSKI_BROJ")}:
              </span>
            </Col>
            <Col span={12}>
              <Input
                onChange={(e) =>
                  setInformacijeSkladista({
                    postanskiBrojSkladista: e.target.value,
                  })
                }
                className={`${style.fontSize} w-93`}
                value={stateValues.postanskiBrojSkladista}
                name="postanski-broj"
              />
            </Col>
          </Row>
          <Row className={style.leftCol}>
            <Col span={11} className="alignRight pr-7">
              <span className={style.fontSize}>
                {MandatoryField("AKCIZNE_DOZVOLE.MESTO_SKLADISTA")}:
              </span>
            </Col>
            <Col span={12}>
              <Input
                onChange={(e) =>
                  setInformacijeSkladista({
                    mestoSkladista: e.target.value,
                  })
                }
                className={`${style.fontSize} w-93`}
                value={stateValues.mestoSkladista}
                name="mesto-skladista"
              />
            </Col>
          </Row>
          <Row className={style.leftCol}>
            <Col span={11} className="alignRight pr-7">
              <span className={style.fontSize}>
                {MandatoryField("AKCIZNE_DOZVOLE.OZNAKA_SKLADISTA")}:
              </span>
            </Col>
            <Col span={12}>
              <Input
                onChange={(e) =>
                  setInformacijeSkladista({
                    oznakaSkladista: e.target.value,
                  })
                }
                value={stateValues.oznakaSkladista}
                className={`${style.fontSize} w-93`}
                name="oznaka-skladista"
              />
            </Col>
          </Row>
          <Row className={style.leftCol}>
            <Col span={11} className="alignRight pr-7">
              <Select
                value={stateValues.meraVelicineSkladista}
                allowClear
                onChange={(e) =>
                  setInformacijeSkladista({ meraVelicineSkladista: e })
                }
                options={meraOptions || []}
                name="mera-edit"
                className={style.fontSize}
                placeholder={t("PLACEHOLDERS.MERA")}
              />
            </Col>
            <Col span={12}>
              <InputNumber
                min={0}
                onChange={(value) =>
                  setInformacijeSkladista({
                    meraVrednost: value,
                  })
                }
                placeholder={t("PLACEHOLDERS.VREDNOST_POVRSINE_ZAPREMINE")}
                className={`${style.fontSize} w-93`}
                value={stateValues.meraVrednost}
                name="vrednost-povrsine"
              />
            </Col>
          </Row>
        </Col>

        <Col span={12} className="pl-85">
          <div className="pb-15">
            <span className={style.fontSize}>
              {MandatoryField("AKCIZNE_DOZVOLE.OPIS_AKCIZNOG_SKLADISTA")}
            </span>
          </div>
          <TextArea
            onChange={(e) =>
              setInformacijeSkladista({
                opisSkladista: e.target.value,
              })
            }
            value={stateValues.opisSkladista}
            className={`${style.fontSize} mb-15`}
            rows={4}
          />
          <div className="pb-15">
            <span className={style.fontSize}>
              {MandatoryField(
                "AKCIZNE_DOZVOLE.OPIS_RADA_SISTEMA_RACUNOVODSTVA"
              )}
            </span>
          </div>
          <TextArea
            onChange={(e) =>
              setInformacijeSkladista({
                opisRadaRacunovodstva: e.target.value,
              })
            }
            value={stateValues.opisRadaRacunovodstva}
            className={style.fontSize}
            rows={4}
          />
        </Col>
      </Row>
    </Col>
  );
};
